import { KPIInfo } from "../../services/interfaces/IHomePage";
import { numberFormatter } from "../../utils/formatter";
import SafeArrowUpSm from "../../assets/up-arrow-sm-safe.svg"
import AlertArrowDownSm from "../../assets/down-arrow-sm-danger.svg";
import moment from "moment";
import { getYTDTransactionRange } from "../../utils/helpers/mapModulesToIcon";

type Props = { kpi: KPIInfo[], key: number, refreshed_date: string }

const getTitle = (kpiName: string, entity: string, refreshed_date: string) => {
    let refreshDateKPIs = ['ytd_spend', 'ytd_volume', 'ytd_sales', 'ytd_tm']
    if (refreshDateKPIs?.includes(kpiName)) {
        return (<div>as of <span className="text-deloitteGreen">{moment.utc(refreshed_date).format("MM/DD")}</span></div>);
    }

    // else if(kpiName === 'ytd_tm')
    // {
    //   return (<div>for <span className="text-deloitteGreen">{getYTDTransactionRange()}</span></div>)
    // }
    return entity;
}


const KPICard = ({ kpi, refreshed_date }: Props) => {
    return (
        <div className="bg-white shadow-module-card rounded-md border border-[#BEBEBE] flex flex-col justify-between items-start h-full w-full p-[1vh]">
            <div className="flex justify-between w-full">
                <div className="w-full"> <div className={`font-bold text-[0.75vw] ${kpi[0].title.includes('Purchase') && 'max-w-[80%]'} max-w-[48%] ${kpi[0].title.includes('Margin') && 'max-w-[30vh]'}`}>{kpi[0].title}</div>
                    <div className="font-bold text-[0.65vw]">{getTitle(kpi[0].kpi, kpi[0].title, refreshed_date)}</div>
                </div>
                <span className={`font-bold text-[0.75vw] text-right ${kpi[0].title.includes('Margin') && 'max-w-[16vh]'}`}>{kpi[1].title}</span>
            </div>

            <div className="flex justify-between w-full">
                <span>{
                    kpi[0].unit === '$' ?
                        <span className="font-normal text-[2.5vw]">
                            {numberFormatter(kpi[0].value, numberFormatter(kpi[0].value).slice(-1) === 'M' ? 1 : 0, '$')}
                        </span> :
                        (kpi[1].title?.includes('Margin') ? <span className="font-normal text-[2.5vw]">
                            {kpi[0].value?.toFixed(1)}
                            <span className="text-[0.8vw]">{kpi[0].unit}</span>
                        </span> : <span className="font-normal text-[2.5vw]">
                            {numberFormatter(kpi[0].value, ["M"].includes(numberFormatter(kpi[0].value).slice(-1)) ? 1 : 0)}
                            <span className="text-[0.8vw]">{kpi[0].unit}</span>
                        </span>)

                }
                </span>
                <span className="font-normal text-[1.8vh] self-end flex gap-2 items-center">
                    {kpi[1].title.includes('Margin') ? kpi[1].value?.toFixed(2) : numberFormatter(Math.abs(kpi[1].value * 100), 1)}%
                    <span>
                        {kpi[1].value > 0 && (
                            <img src={SafeArrowUpSm} alt="safe"></img>
                        )}

                        {kpi[1].value < 0 && (
                            <img src={AlertArrowDownSm} alt="danger"></img>
                        )}
                    </span>
                </span>
            </div>
        </div>
    )
}

export default KPICard;